export default __webpack_public_path__ + "static/media/Bannerprincipal.9aea4b9b.png";